import React, { Component } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { MDBIcon } from 'mdbreact';
import '../Pages/StylesAdmin.css';
import Swal from 'sweetalert2';
import { getProfile } from '../../services/WebAPI_Utrahuilca';
import { URLImgFront } from '../../config/URLDB';
import InicioGlobal from '../Components/InicioGlobal';
import ReporteSolicitudVacantes from '../ComponentsTH/Reportes/ReporteSolicitudVacantes';

class PrincipalTalentoH extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            active: '1',
            nombre: '',
            cargo: ''
        };
    }
    componentDidMount() {
        this.loadProfile();
    }

    restart() {
        sessionStorage.removeItem('idusuariotalentoh');
        sessionStorage.removeItem("usuariotalentoh");
        this.props.history.push('/admin/talentoHumano');
    }

    loadProfile() {
        if (sessionStorage.length > 0) {
            const dataparametro = {
                idusuario: parseInt(sessionStorage.getItem('idusuariotalentoh')),
                usuario: sessionStorage.getItem("usuariotalentoh")
            }
            getProfile(dataparametro).then(response => {
                try {
                    if (response.data.length > 0) {
                        this.setState({
                            nombre: response.data[0].nombrecomp,
                            cargo: response.data[0].cargo
                        });
                    } else {
                        this.restart();
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: response.data[0].descMessage
                    });
                    this.restart();
                }
            });
        } else {
            this.restart();
        }
    }

    render() {
        const { expanded, active } = this.state;
        return (
            <React.Fragment>
                <SideNav
                    onSelect={(selected) => {
                        this.setState({
                            active: selected
                        });
                    }}
                    expanded={expanded}
                    onToggle={(expanded) => {
                        this.setState({ expanded });
                    }}
                    className="sidenav-design"
                >
                    <SideNav.Toggle
                        className="sideNavToggle"
                        onClick={() => this.setState({ expanded: !expanded })}
                    />
                    <SideNav.Nav className="sideNavNav">
                        <NavItem eventKey="1" className="items">
                            <NavIcon>
                                <MDBIcon icon="home" size="2x" />
                            </NavIcon>
                            <NavText>
                                Inicio
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="0" className="items">
                            <NavIcon>
                                <img
                                    src={`${URLImgFront}/assets/iconos/utrahuilca-cv.svg`}
                                    alt="Reportes"
                                    className="custom-icon"
                                />
                            </NavIcon>
                            <NavText>
                                Reportes
                            </NavText>
                            <NavItem eventKey="01" className="item">
                                <NavText>
                                    Solicitud Vacantes
                                </NavText>
                            </NavItem>
                        </NavItem>
                    </SideNav.Nav>
                </SideNav>
                <main className="pl-5 ml-5 py-5 pr-5 container_fondo">
                    <img className="img-fluid img_logo" src={`${URLImgFront}/assets/logo/utrahuilca-logo.svg`} alt="logo" width="500" />
                    <div className="contenedor">
                        {(() => {
                            switch (active) {
                                case '1': return <InicioGlobal
                                                    usuario={this.state.nombre}
                                                    cargo={this.state.cargo}
                                                    idUsuarioKey="idusuariotalentoh"
                                                    usuarioKey="usuariotalentoh"
                                                    redirectPath="/admin/talentoHumano"
                                                />;
                                case '01': return <ReporteSolicitudVacantes />;
                                default: return <InicioGlobal
                                                    usuario={this.state.nombre}
                                                    cargo={this.state.cargo}
                                                    idUsuarioKey="idusuariotalentoh"
                                                    usuarioKey="usuariotalentoh"
                                                    redirectPath="/admin/talentoHumano"
                                                />;
                            }
                        })()}
                    </div>
                </main>
            </React.Fragment>
        );
    }
}
export default PrincipalTalentoH;